module.exports = __webpack_public_path__ + "static/media/uga.b98f16fa.png";